import { WarningIcon } from "@chakra-ui/icons";
import { Box, Alert, AlertIcon, AlertTitle, AlertDescription } from "@chakra-ui/react";

function WarningBanner() {
  return (
    <Alert status="warning" borderRadius="md" mb={4}>
      <AlertIcon />
      <Box>
        <AlertTitle fontSize="lg">DO NOT USE</AlertTitle>
        <AlertDescription>Not ready for public use! Accounts can be created but unable to trade without prior approval. </AlertDescription>
      </Box>
    </Alert>
  );
}

export default WarningBanner;
